import type { SelectProps } from "@heroui/react";
import {
	BOARDS_KEY_MAPPER_ENUM,
	OPERATION_COLUMNS,
} from "@onesolution/constants";
import { type AppFormApi, useLanguage } from "@onesolution/hooks";
import { getStatusChoicesFromServer } from "@onesolution/serverFn";

export default function EntitiesSelector(
	props: {
		name: string;
		form: AppFormApi;
	} & Omit<SelectProps, "children" | "form">,
) {
	const { t } = useLanguage();
	const { form, name, ...restProps } = props;
	const entities = getStatusChoicesFromServer.useQuery({
		boardId: BOARDS_KEY_MAPPER_ENUM.briefs,
		columnId: OPERATION_COLUMNS.entities,
	});

	return (
		<form.AppField name={name}>
			{(field) => (
				<field.SelectMultiple
					label={t("name.entities")}
					placeholder={t("name.entities")}
					items={entities.data}
					isLoading={entities.isLoading}
					{...restProps}
				/>
			)}
		</form.AppField>
	);
}
